module.exports = __webpack_public_path__ + "static/media/IMG_8753.0aa64c79.jpg";